import React from 'react';
import Logo from '../../assets/logo.svg';
import activedashboardIcon from '../../assets/menu/Iconly-Bold-Graph.svg';
import activewallet from '../../assets/activemenu/Iconly-Bold-Wallet.svg';
import wallet from '../../assets/menu/Iconly-Bold-Wallet.svg';
import order from '../../assets/menu/Iconly-Bold-Filter.svg';
import addFriends from '../../assets/menu/Iconly-Bold-Add User.svg';
import Profil from '../../assets/menu/Profile.svg';
import notification from '../../assets/menu/Iconly-Bold-Notification.svg';
import setting from '../../assets/menu/Iconly-Bold-Setting.svg';
import dashboardIcon from '../../assets/activemenu/Iconly-Bold-Graph.svg';
import orderIcon from '../../assets/order/Iconly-Bold-Filter.svg';
import { Link, NavLink, useHistory, withRouter } from 'react-router-dom';
import invitefriendsActive from '../../assets/invitefriends/Iconly-Bold-Add User.svg';

const MenuItem = ({ icon, iconActive, title, url, currentURL }) => {
    return (
        <NavLink to={url} exact>
            <li>
                <img src={currentURL === url ? iconActive : icon} alt={title} />
                <p>{title}</p>
            </li>
        </NavLink>
    );
};
const Navigation = () => {
    const history = useHistory();
    const currentURL = history.location.pathname;
    const items = [
        {
            title: 'داشبود',
            icon: dashboardIcon,
            iconActive: activedashboardIcon,
            url: '/dashboard',
        },
        {
            title: 'کیف پول',
            icon: wallet,
            iconActive: activewallet,
            url: '/wallet',
        },
        {
            title: 'سفارشات',
            icon: order,
            iconActive: orderIcon,
            url: '/order',
        },
        {
            title: 'دعوت از دوستان',
            icon: addFriends,
            iconActive: invitefriendsActive,
            url: '/invite-friend',
        },
    ];
    const profileName = 'سینا قدری';
    return (
        <>
            <header className="header">
                <div className="header-part">
                    <NavLink to={'/dashboard'} exact>
                        <div className="header-logo">
                            <img src={Logo} alt="logo" />
                            <h3>بی بیت</h3>
                        </div>
                    </NavLink>

                    <nav className="header-nav">
                        <ul className="hidden-md-down">
                            {items.map((i, index) => (
                                <MenuItem
                                    icon={i.icon}
                                    iconActive={i.iconActive}
                                    title={i.title}
                                    url={i.url}
                                    currentURL={currentURL}
                                    key={'MenuItem-' + index}
                                />
                            ))}
                        </ul>
                    </nav>
                </div>

                <div className="header-part">
                    <div className="header-options">
                        <NavLink to="/profile" exact activeClassName="header-options-item-active">
                            <div className="header-options-profile">
                                <p className="hidden-md-down">{profileName}</p>
                                <div className="header-options-icon header-options-icon-avatar">
                                    <img alt="user" src={Profil} />
                                </div>
                            </div>
                        </NavLink>
                        <NavLink to="/notification" exact>
                            <div className="header-options-icon header-options-icon-notification">
                                <img alt="notiication" src={notification} />
                            </div>
                        </NavLink>
                        <NavLink to="/setting" exact activeClassName="header-options-item-active">
                            <div className="header-options-icon header-options-icon-setting">
                                <img alt="setting" src={setting} />
                            </div>
                        </NavLink>
                    </div>
                </div>
            </header>
        </>
    );
};

export default withRouter(Navigation);
